import { Box, Button, Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import star from "../../assets/star.png";
import MetaDiscover from "../../assets/meta.png";

let data = [
  {
    number: "01",
  },
  {
    number: "02",
  },
  {
    number: "03",
  },
  {
    number: "04",
  },
];

const Meta = () => {
  return (
    <Box
      sx={{
        background: `url(${star}), #021B33`,
        backgroundSize: "100% 100%",
        height: "100%",
        minHeight: "100vh",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container sx={{ py: 5 }}>
        <Grid container spacing={5}>
          <Grid item md={6} xs={12}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={MetaDiscover} alt="MetaDiscover" />
              <Typography
                sx={{
                  fontSize: "31.68px",
                  fontFamily: "Zen Dots",
                  fontWeight: "400",
                  color: "rgba(255, 255, 255, 1)",
                  pt: 3,
                }}
              >
                WHAT IS Meta?
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "14.4px" },
                  fontFamily: "Inter",
                  fontWeight: "400",
                  color: "rgba(255, 255, 255, 1)",
                  py: 3,
                  px: 6,
                  textAlign: "center",
                }}
              >
                Approving Meta is a collection of 9,999 adorable corgis living
                on the Ethereum blockchain
              </Typography>
              <Button
                sx={{
                  my: 2,
                  color: "white",
                  display: "block",
                  background:
                    "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                }}
              >
                WhitePaper
              </Button>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Grid container spacing={4}>
              {data.map(({ number }, index) => (
                <Grid item md={6} sm={6} xs={12} key="index">
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "35px",
                        fontFamily: "Zen Dots",
                        fontWeight: "400",
                        background:
                          "-webkit-linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        pt: 3,
                      }}
                    >
                      {number}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "13px", md: "16px" },
                        fontFamily: "Zen Dots",
                        fontWeight: "400",
                        color: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      Institutional Investors
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", md: "14px" },
                        fontFamily: "Inter",
                        fontWeight: "400",
                        color: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book.
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Meta;
